// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".niPHUpdrD3QNPeqooJVJJQ\\=\\=,.niPHUpdrD3QNPeqooJVJJQ\\=\\=>div{display:flex;align-items:center;justify-content:center}", "",{"version":3,"sources":["webpack://./components/IconButton/styles.module.scss"],"names":[],"mappings":"AACE,4DAEE,YAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":[".buttonContainer {\n  &,\n  > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContainer": "niPHUpdrD3QNPeqooJVJJQ=="
};
export default ___CSS_LOADER_EXPORT___;
